import axios from "axios";

export const clientGQL = async (query, variables = {}) => {
    const headers = { "Content-Type": "application/json", 'Authorization': `Bearer ${localStorage.getItem('authToken')}` };
    const res = await axios.post(process.env.REACT_APP_HASURA_SERVER_URL, JSON.stringify({ query, variables }), {
        headers: headers
    })
    return res.data;
};